<template>
  <div class="fillcontain" v-loading="loading">
    <head-top></head-top>
    <el-row style="margin-top: 20px;" >
      <el-col :span="20">
        <el-form :model="formData"  ref="formData" label-width="120px" class="demo-formData">
          <el-form-item label="素材名称">
            <el-input v-model="formData.name" placeholder="请输入素材名称" maxlength="15" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="课程分类">
            <el-select v-model="formData.classify" placeholder="请选择" style="width: 200px" @change="onSelectedDrug">
              <el-option
                v-for="item in option1"
                :key="item.typeId"
                :label="item.typeName"
                :value="item.typeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="子目录" >
            <el-select v-model="formData.catalog" placeholder="请选择" style="width: 200px" @change="onSelectedDrug1">
              <el-option
                v-for="item in option2"
                :key="item.typeId"
                :label="item.typeName"
                :value="item.typeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课程">
            <el-select v-model="formData.curriculum" placeholder="请选择" style="width: 200px">
              <el-option
                v-for="item in option3"
                :key="item.courseId"
                :label="item.courseName"
                :value="item.courseId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="素材内容" prop="name">
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入内容"
              v-model="formData.textarea">
            </el-input>
          </el-form-item>
          <div class="but_bot">
            <el-button type="primary" @click="submit()">提交</el-button>
            <el-button type="primary" @click="cancel()">取消</el-button>
          </div>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getselectPrimary,getselectSecondType,getselectCourseName,getaddMaterial } from "../api/api"
  import axios from 'axios'
  export default {
    inject: ['reload'],
    data(){
      return {
        formData:{
          name:'',
          curriculum:'',
          textarea:'',
          catalog:'',
          classify:''
        },
        option1:[],
        option2:[],
        option3:[],
        typeName:'',
        loading:false
      }
    },
    components: {
      headTop,
    },

    methods: {
      //时间戳转换
      getcourseType () {
        let params = {
          category: 2
        };
        //获取文字素材一级分类
       getselectPrimary(params).then(res => {
          this.option1 = res
        }).catch(error => {
          console.log(error);
        })
      },
      onSelectedDrug () {
        let params = {
          category: 2,
          parentId:this.formData.classify,
        };
        //获取文字素材二级分类
        getselectSecondType(params).then(res => {
          this.option2 = res
        }).catch(error => {
          console.log(error);
        })
      },
      onSelectedDrug1 () {
        let params = {
          category: 2,
          typeId:this.formData.catalog,
        };
        //获取文字素材三级分类
        getselectCourseName(params).then(res => {
          console.log(res)
          this.option3 = res
        }).catch(error => {
          console.log(error);
        })
      },
      submit(){
        if (this.formData.name == '' || this.formData.textarea == ''|| this.formData.curriculum == ''){
          this.$message({
            type: 'error',
            message: '请填写完整信息'
          });
        } else {
          this.loading = true
          let params = {
            classifyId: this.formData.curriculum,
            materialName:this.formData.name,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
            materialContent:(this.formData.textarea.replace(/\n/g, "/n")).replace(/ /g, "/t")
          };
          getaddMaterial(params).then(res => {
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.loading = false
              this.reload()
              this.formData = {}
            }else{
              this.$message({
                type: 'error',
                message: '请上传正确信息'
              });
              this.loading = false
            }
          }).catch(error => {
            this.loading = false
            console.log(error);
          })
        }
      },
      cancel(){
        this.reload()
        this.formData = {}
        this.$router.push('materrial')
      }
    },
    mounted(){
      this.getcourseType();
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
  .el-textarea__inner{
    width: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/page/addText.vue